module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAATCAYAAABPwleqAAABR0lEQVQ4T62UMUvDUBDHf0ekFBzs4ObiVHRzdavuroJoIKgvdOlSB2exfgCn0hRsQdChuOjqJH4BEXfRwc2kiwiJOQk0IrW1Mfi2d/x//3vv3d0TAGNMDVgIw3Cv2+2+J7EsSxzHKRUKhUdgBrhX1Y12u/2QCR5kXhKR8yQ78AbUPc9rTTKQVGDb9nSxWDwWkW0giV9YlmWazaY/zuQLTgXGmHWgJSIl4AnY9DzvdpTBDzgRVavV+TiOz4BlIFLVwyAIjnq93sd3k5FwIqhUKlPlcvkA2Acs4CYMw61Op/OcGoyFU4HruivAKTCnqq8isuP7/lVyiolwYuK67ixwAqypqgIvqupkggenEGPMtYisDvZ3meDcmYfvDOwGQXD5651zv/ZwneM4bvT7/cbEOufqsNy9bYzJN1X/Mc81VV2Moqj+l5/kE6i3rPjHyS1iAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/moreIcon.png
// module id = h4mR
// module chunks = 2